import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["button"]

  submitStart() {
    if (this.hasButtonTarget) {
      this.buttonTarget.disabled = true
      this.buttonTarget.textContent = "Checking…"
    }
  }

  submitEnd() {
    if (this.hasButtonTarget) {
      this.buttonTarget.disabled = false
      this.buttonTarget.textContent = "Check now"
    }
  }
}
